<template>
  <div>
    <time-line class="mt-4">
      <div v-for="(item, index) in listOfSignatures" :key="index">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <div>
              <img src="@/assets/img/sign.svg" />
            </div>
          </template>
          <template #date v-if="item.signatureDate">
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.signatureDate | date }}
              </div>
              <div class="color-black font-12 font-weight-bold hour">
                {{ item.signatureDate | hour }}
              </div>
            </div>
          </template>
          <div class="row mx-1">
            <div class="col col-md-2">
              <div class="color-gray-6 font-14 font-weight-normal">
                Nombre:
              </div>
              <div class="color-black font-16 font-weight-normal label-value">
                {{ item.name | empty }}
              </div>
            </div>
            <div class="col col-md-3">
              <div class="color-gray-6 font-14 font-weight-normal">
                Puesto:
              </div>
              <div class="color-black font-16 font-weight-normal label-value">
                {{ item.position.signaturePositionName | empty }}
              </div>
            </div>
            <div class="col col-md-2">
              <div class="color-gray-6 font-14 font-weight-normal">
                Tipo de Firma:
              </div>
              <div class="color-black font-16 font-weight-normal label-value">
                {{ item.signatureType.name | empty }}
              </div>
            </div>
            <div class="col col-md-2">
              <div class="color-gray-6 font-14 font-weight-normal ml">
                Firmado por:
              </div>
              <div
                class="color-black font-16 font-weight-normal label-value ml"
              >
                {{ item.name | empty }}
              </div>
            </div>
            <div class="col col-md-1 d-flex justify-content-end">
              <div class="vertical-line"></div>
            </div>
            <div class="col col-md-2">
              <div class="color-gray-6 font-14 font-weight-normal">
                Representante:
              </div>
              <div class="color-black font-16 font-weight-normal label-value">
                {{ getGroupName(item) | empty }}
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from "@quisit/mipe-timeline";
import CustomResultNotFound from "custom-result-not-found";

export default {
  name: "SignatureHistory",
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound
  },
  props: {
    listOfSignatures: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getGroupName(item) {
      let groupId = item.groupId;
      // JSF: Si el groupId viene 0 es que estan agregando una agencia desde la seccion de la parte
      // (IX. Participación de la familia y otras agencias del TAB 9). Asi que añadimos un nombre por defecto
      // porque no encontrara el nombre del grupo.
      const defaultSignatureGroupName =
        groupId === 0 || groupId === 13
          ? "Otras personas con experiencia o peritaje"
          : "";

      const signatureGroupName = this.options.find(
        x => x.signatureGroupId == groupId
      )?.signatureGroupName;
      return defaultSignatureGroupName || signatureGroupName;
    }
  }
};
</script>

<style scoped>
.vertical-line {
  border-left: 2px solid #dfe9e4;
  height: 50px;
}
</style>
